'use client'
import { forwardRef, useState } from 'react'
import { Input, InputProps } from '@/root/ui/tuuleliinid/Input/Input'
import { ShowPasswordIcon } from '@/root/ui/shared/icons/ShowPasswordIcon'
import { HidePasswordIcon } from '@/root/ui/shared/icons/HidePasswordIcon'

export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type' | 'endIcon'>>(
  (props, ref) => {
    const [visible, setVisible] = useState(false)

    return (
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        endIcon={
          <button
            type="button"
            onClick={() => setVisible((prev) => !prev)}
            className="absolute end-3 top-1/2 -translate-y-1/2"
          >
            {visible ? <HidePasswordIcon /> : <ShowPasswordIcon />}
          </button>
        }
        {...props}
      />
    )
  },
)

PasswordInput.displayName = 'PasswordInput'
